
import * as tinyCookie from "tiny-cookie";
import Vue from "vue";
import * as Sentry from "@sentry/vue";

export default Vue.extend({
  name: "Cookie",
  props: {
    debug: {
      type: Boolean,
      default: false,
    },

    // slideFromBottom, slideFromTop, fade
    transitionName: {
      type: String,
      default: "slideFromBottom",
    },

    showPostponeButton: {
      type: Boolean,
      default: false,
    },

    forceCookies: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      supportsLocalStorage: true,
      isOpen: false,
      cookieCategories: [
        { id: 'essential', name: 'Essential', description: 'Required for website functionality.' },
        { id: 'analytics', name: 'Analytics', description: 'Helps us understand website usage.' },
        { id: 'marketing', name: 'Marketing', description: 'Used for targeted advertising.' },
      ],
      consentPreferences: {
        essential: true,
        analytics: false,
        marketing: false,
      },
    };
  },
  mounted() {
    this.checkLocalStorageFunctionality();
    this.init();
  },
  methods: {
    init() {
      let haveConsent =this.loadConsent();

      if (!haveConsent) {
        this.consentPreferences = {
          essential: true,
          analytics: false,
          marketing: false,
        };
        this.isOpen = true;
      } else {
        this.applyConsent();
      }
    },
    toggleConsent(category) {
      if (category.id === 'essential') {
        this.consentPreferences.essential = true; // Essential cookies are always accepted
      } else {
        this.consentPreferences[category.id] = !this.consentPreferences[category.id];
      }
    },
    applyConsent() {
      // GTM is already loaded from consent.js, just update consent
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
          ad_user_data: this.consentPreferences.marketing ? 'granted' : 'denied',
          ad_personalization: this.consentPreferences.marketing ? 'granted' : 'denied',
          ad_storage: this.consentPreferences.marketing ? 'granted' : 'denied',
          analytics_storage: this.consentPreferences.analytics ? 'granted' : 'denied'
        });
      }
    },
    acceptAll() {
      this.cookieCategories.forEach(category => {
        this.consentPreferences[category.id] = true;
      });
      this.saveConsent();
    },
    savePreferences() {
      this.consentPreferences.essential = true; // Essential cookies are always accepted
      this.saveConsent();
    },
    saveConsent() {
      if (this.supportsLocalStorage) {
        localStorage.setItem(`bikeflights-consent-preferences`, JSON.stringify(this.consentPreferences));
      } else {
        tinyCookie.set(`bikeflights-consent-preferences`, JSON.stringify(this.consentPreferences));
      }
      this.applyConsent();
      this.isOpen = false;
      this.$emit("clicked-accept");
    },
    loadConsent() {
      if (this.supportsLocalStorage) {
        const consent = localStorage.getItem(`bikeflights-consent-preferences`);
        if (consent) {
          this.consentPreferences = JSON.parse(consent);
          return true;
        }
        return false;
      } else {
        const consent = tinyCookie.get(`bikeflights-consent-preferences`);
        if (consent) {
          this.consentPreferences = JSON.parse(consent);
          return true;
        } 
        return false;
      }
    },
    checkLocalStorageFunctionality() {
      if (this.forceCookies) {
        this.supportsLocalStorage = false;
        return;
      }
      // Check for availability of localStorage
      try {
        const test = "__bikeflights-consent-check-localStorage";
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
      } catch (e) {
        Sentry.captureException(e, {
          tags: { action: "checkLocalStorageFunctionality" }
        });
        this.supportsLocalStorage = false;
      }
    },
  },
});
